import { render, staticRenderFns } from "./ClientReview.vue?vue&type=template&id=4297e9f8&scoped=true&"
import script from "./ClientReview.vue?vue&type=script&lang=ts&"
export * from "./ClientReview.vue?vue&type=script&lang=ts&"
import style0 from "./ClientReview.vue?vue&type=style&index=0&id=4297e9f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4297e9f8",
  null
  
)

export default component.exports